<script>
	import {Gtag} from '../../mixins/ga'
	import {Form} from '../../helpers/Form/Form'

	export default {
		mixins: [Gtag],
		props: {
			reviewsCount: {
				type: Number,
				default: 0
			},
			course: Number
		},
		data() {
			return {
				isMobile: window.isMobile(),
				data: null,
				lessonPackages: [],
				subscriptions: [],
				fees: [],
				reviews: [],
				reviewsPagination: {},
				fetch: new Form({}),
				form: new Form({
					items: []
				}),
        mobileDetect: window.innerWidth < 1000,
      }
		},
		computed: {
			collapseReviews() {
				return !this.isMobile && this.reviewsCount > 0
				// return true
			},
			disabledLoadMoreReviews() {
				if (this.reviewsPagination) {
					return this.reviewsPagination.total == this.reviews.length
				}
				return false
			}
		},
		mounted() {
            window.addEventListener('resize', (e) => {
                this.isMobile = window.isMobile()
            })			

            this.getPackages()

            window.onresize = () => {
              console.log(window.innerWidth)
              this.$set(this, 'mobileDetect', window.innerWidth < 1000)
            }

		},
		methods: {		
			async getPackages() {
				let response = await this.fetch.get(route('courses.packages', this.course))

				this.$set(this, 'fees', response.fees)
				this.$set(this, 'lessonPackages', response.lessonPackages)
				this.$set(this, 'subscriptions', response.subscriptions)
				this.$set(this, 'data', response.course)

				await this.loadReviews()
			},
			async loadReviews() {
				let url = route('courses.reviews', this.course)

				if (this.reviewsPagination.hasOwnProperty('next_page_url')) {
					url = this.reviewsPagination.next_page_url
				}

				await this.fetch.get(url)
					.then(({reviews}) => {
						this.$set(this, 'reviewsPagination', reviews)
						this.$set(this, 'reviews', this.reviews.concat(this.reviewsPagination.data))
					})
			},
            dateFormatter(date, format = 'DD/MM/YYYY') {
                return moment(date).format(format);
            },			
			onAddToCart() {
				this.form
					.submit('post', route('cart.multiple_store'))
					.then(response => {
						this.sendCourseAddToCartGaEvent()

	                    window.alerts.success(response.message);
	                    window.location = '/carts'						
					})
			},
			onSubmitTrial() {
                this.sendGaEvent(
                    'Prenotazionestart', 
                    'Corsi', 
                    '#prenota-prova-step0'
                )

				this.$bus.$emit('reservation-trial', {
					value: 1,
					key: 'desktop-v1',
					type: 'lessons',
				})

				$("#reservationModal").modal('show')
			},
			onSubmitEntry(courseId = null) {
				try {
                  this.sendGaEvent(
	                    'Prenotazionestart', 
	                    'Corsi', 
	                    '#prenota-ingresso.step0'
	                )
	            } catch (e) {

	            }

				this.$bus.$emit('reservation-trial', {
					value: 0,
					type: 'entries',
					key: 'modal',
          courseId: courseId
				})
			},
			goToOtherCourses(target) {
				$('html,body').animate({
					scrollTop: $(`#${target}`).offset().top
				},'slow');

				this.sendGaEvent(
					'Scopri',
					'Corsi',
					'#scopri-corsi'
				)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseContainer.vue